// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__URTmz","content":"styles_content__gks51","column":"styles_column__dCuS7","secondReviews":"styles_secondReviews__rhlhE"};